import { useTranslator } from "@eo-locale/react";

import { AiOutlineInfo } from "react-icons/ai";

import { Fragment, ReactNode } from "react";

import { Box, Flex } from "@/storybook-components";
import ActionButton from "./action-button";

function StickyActionBar({
  actions,
  splitActions,
  open,
  onClose
}: {
  open?: boolean;
  actions: { component: ReactNode; position: "left" | "right" }[];
  splitActions?: boolean;
  onClose?: () => void;
}) {
  const { translate } = useTranslator();

  if (splitActions) {
    const leftActions = actions.filter(({ position }) => position === "left");
    const rightActions = actions.filter(({ position }) => position === "right");

    return (
      <Box py={4} width="100%">
        <Flex justify="space-between">
          <Flex gap={4}>
            {onClose && (
              <ActionButton
                type="icon"
                onClick={onClose}
                icon={<AiOutlineInfo size={20} />}
                label={
                  open
                    ? translate("common.closePanel")
                    : translate("common.openPanel")
                }
                dataTestId={open ? "ideas-close-panel" : "ideas-open-panel"}
              />
            )}

            {leftActions.map(
              ({ component }, index) =>
                component && <Fragment key={index}>{component}</Fragment>
            )}
          </Flex>
          <Flex gap={4}>
            {rightActions.map(
              ({ component }, index) =>
                component && <Fragment key={index}>{component}</Fragment>
            )}
          </Flex>
        </Flex>
      </Box>
    );
  }

  return (
    <Box py={4} width="100%">
      <Flex gap={4} justify="space-between">
        {onClose && (
          <ActionButton
            type="icon"
            onClick={onClose}
            icon={<AiOutlineInfo size={20} />}
            label={
              open
                ? translate("common.closePanel")
                : translate("common.openPanel")
            }
            data-testid={open ? "ideas-close-panel" : "ideas-open-panel"}
          />
        )}

        {actions.map(
          ({ component }, index) =>
            component && <Fragment key={index}>{component}</Fragment>
        )}
      </Flex>
    </Box>
  );
}

export default StickyActionBar;
